import APICall from "../utils/APICall";

export default class PreOnboardServices {
  static getAccount = async (accountNo) => {
    return await APICall(
      `/api/PreOnboardedUser/admin/account-details/${accountNo}`,
      "GET"
    );
  };
  static preOnboardUser = async (data) => {
    return await APICall(
      `/api/PreOnboardedUser/admin/pre-onboard`,
      "POST",
      data
    );
  };
  static getAllUsers = async (page, pagelimit, search = "") => {
    return await APICall(
      ` /api/PreOnboardedUser/admin/pre-onboarded-users?page=${page}&pageLimit=${pagelimit}&search=${search}`,
      "GET"
    );
  };
  static Activate = async (data = {}) => {
    return await APICall(
      `/api/PreOnboardedUser/admin/pre-onboarded-user/approve`,
      "POST",
      data
    );
  };
  static Reset = async (data = {}) => {
    return await APICall(
      `/api/PreOnboardedUser/admin/pre-onboarded-user/re-initiate`,
      "POST",
      data
    );
  };

  static acceptUploads = async (fileData) => {
    return await APICall(
      `/api/PreOnboardedUser/admin/pre-onboarded-user/bulk`,
      "POST",
      fileData
    );
  };

  static approveUploads = async () => {
    return await APICall(
      `/api/PreOnboardedUser/admin/pre-onboarded-user/approve/all`,
      "POST"
    );
  };

  static resendEmails = async (data) => {
    return await APICall(
      `/api/PreOnboardedUser/admin/pre-onboarded-user/re-send-activation-mail`,
      "POST",
      data
    );
  };
}
